<template>
  <component :is="type" class="dea-badge">
    <span class="dea-badge__label"> <slot /> </span>
  </component>
</template>

<script>
/**
 * I badge di notifica vengono utilizzati per evidenziare messaggi all'interno di elementi quali prodotti, aree dell'account utente o applicazioni. Sono flessibili ed è possibile gestire il colore del background tramite tokens.
 */
export default {
  name: "Badge",
  version: "1.5.0",
  status: "stable",
  props: {
    /**
     * Tag used as component main element.
     */
    type: {
      type: String,
      default: "div",
    },
  },
};
</script>
